import { MenuItem } from '../../../pages/mindmap/types';

export const PanelMenuHeader = ({ expanded, disabled, icon, label, onClick }: MenuItem) => (
  <li className={`p-menuitem ${expanded ? 'p-menuitem-active' : ''}`} onClick={onClick}>
    <a href="#" className={`p-menuitem-link ${disabled ? 'p-disabled' : ''}`} role="menuitem" aria-haspopup="true">
      <span className={`p-menuitem-icon ${icon}`}></span>
      <span className={'p-menuitem-text'}>{label}</span>
      <span className={`p-submenu-icon pi pi-angle-${expanded ? 'down' : 'up'}`}></span>
    </a>
  </li>
);
